import { Box, CircularProgress } from "@material-ui/core";

import React, { useEffect } from "react";
import FooterWithContent from "../../components/StaticComp/Footer/FooterWithContent";
import LandingPageFifthRow from "../../components/StaticComp/LandingPageFifthSection/LandingPageFifthRow";
import LandingPageFourthSection from "../../components/StaticComp/LandingPageFourthSection/LandingPageFourthSection";
import LandingPageSixthSection from "../../components/StaticComp/LandingPageSixthSection/LandingPageSixthSection";

import LandingPageHeader from "../../components/StaticComp/LandingPageHeader/LandingPageHeader";
import ThirdDivision from "../../components/StaticComp/ThirdDivision/ThirdDivision";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import LandingPageSeventhSection from "../../components/StaticComp/LandingPageSeventhSection/LandingPageSeventhSection";
import LandingPageEighthSection from "../../components/StaticComp/LandingPageEighthSection/LandingPageEighthSection";
// import LandingPageNinthSection from "../../components/StaticComp/LandingPageNinthSection/LandingPageNinthSection";
import LandingPageTenthSection from "../../components/StaticComp/LandingPageTenthSection/LandingPageTenthSection";
// import LandingPageEleventhSection from "../../components/StaticComp/LandingPageEleventhSection/LandingPageEleventhSection";
import LandingPageTwelfthSection from "../../components/StaticComp/LandingPageTwelfthSection/LandingPageTwelfthSection";
import FooterNew from "../../components/FooterNew";
import loadable from "@loadable/component";
import InViewWrapper from "../../components/InViewWrapper";

// const LandingPageHeader = loadable(
//   () =>
//     import("../../components/StaticComp/LandingPageHeader/LandingPageHeader"),
//   {
//     fallback: (
//       <div className="w-screen h-screen flex items-center justify-center">
//         <CircularProgress color="primary" />
//       </div>
//     ),
//   }
// );

const LandingPageNinthSection = loadable(
  () =>
    import(
      "../../components/StaticComp/LandingPageNinthSection/LandingPageNinthSection"
    ),
  {
    fallback: (
      <div className="w-screen h-[300px] flex items-center justify-center">
        <CircularProgress color="primary" />
      </div>
    ),
  }
);

const LandingPageEleventhSection = loadable(
  () =>
    import(
      "../../components/StaticComp/LandingPageEleventhSection/LandingPageEleventhSection"
    ),
  {
    fallback: (
      <div className="w-screen h-[300px] flex items-center justify-center">
        <CircularProgress color="primary" />
      </div>
    ),
  }
);

function LandingPage() {
  const history = useHistory();
  const token = useSelector((state) => state.trading.TOKEN);

  if (token) {
    history.push("/trade/BTC");
  }
  return (
    <Box className="bg-[#131517]">
      <LandingPageHeader />
      <ThirdDivision />
      <LandingPageFourthSection />
      <LandingPageFifthRow />
      <LandingPageSixthSection />
      <LandingPageSeventhSection></LandingPageSeventhSection>
      <LandingPageEighthSection></LandingPageEighthSection>
      <InViewWrapper>
        <LandingPageNinthSection></LandingPageNinthSection>
      </InViewWrapper>
      <LandingPageTenthSection></LandingPageTenthSection>
      <InViewWrapper>
        <LandingPageEleventhSection></LandingPageEleventhSection>
      </InViewWrapper>
      <LandingPageTwelfthSection></LandingPageTwelfthSection>
      <FooterNew></FooterNew>
      {/* <FooterWithContent /> */}
    </Box>
  );
}

export default LandingPage;

{
  /* 
        
          <Box>
            
          </Box>
          <Box className={classes.imageHolder}>
            <img
              src={gridRight}
              alt="header background"
              className={classes.gridRightImage}
            />
          </Box>
        </Box>
      </Box> 
      */
}
